export default "__VITE_ASSET__DFkJGtuI__"